import api from '../../api'
import { PricingType } from '../../../common/constants'

export const invoiceCheckerEndpoint = '/web/admin/invoice-checker'

export type InvoiceCheckRequest = {
  tenantId: number
  jobId: number
}

export type InvoiceCheckFindingType =
  | 'invoiced-amount-differs-from-current-price'
  | 'marked-invoiced-without-invoice-line'
  | 'linked-to-multiple-transactions'
  | 'invoice-line-without-item'
  | 'over-invoiced'
  | 'invoiced-more-than-marked-invoiced'

export type InvoiceCheckFinding = {
  type: InvoiceCheckFindingType
  itemId: string | null
  itemName: string
  isLabor: boolean
  visitDate: string | null
  invoiceNumbers: string[]
  invoicedAmount: number | null
  currentAmount: number | null
  difference: number | null
}

export type WorkareaInvoiceCheck = {
  workareaId: number
  workareaName: string
  groupName: string
  pricingType: PricingType
  billable: number
  invoiced: number
  markedInvoiced: number
  stillToInvoice: number
  unbilledOnInvoiceScreen: number
  findings: InvoiceCheckFinding[]
}

export type InvoiceCheckResult = {
  jobId: number
  workareas: WorkareaInvoiceCheck[]
}

export const checkJobInvoices = async (request: InvoiceCheckRequest): Promise<InvoiceCheckResult> => {
  return (await api.post(invoiceCheckerEndpoint, request)).data
}
